import { useEffect, useState } from "react"
import { useOrganizationContext } from "../../context/OrganizationContext"
import { useUserContext } from "../../context/UserContext"
import { CustomCheckbox } from "../common/CustomCheckbox"
import { ApplicationStorage } from "../../api/applicationStorage"
import { Api } from "../../api/api"
import { Router, useHistory } from "react-router-dom"
import { useCustomTranslation } from "../../helpers/CustomTranslationsComps"
import { DatePicker, NumberField, Text, TextArea } from '../CreateContribution/formComponents/FormComponents'
import {
  CreateOrgRelation,
  RegistrationCountryFieldType,
  RegistrationDateFieldType,
  RegistrationFieldType,
  RegistrationFormType,
  UserLogin
} from '../../types'
import { CountriesDropDown } from "./CountriesDropDown"
import { DropDownSelect } from "../common/DropDownSelect"

type LoginError = {
  show: boolean
  message: string
}

type GenderOptionType = {
  value: string
  label: string
}

interface props {
  userInfo: UserLogin;
  onClose: () => void;
}


export const CreateUserOrgRole = ({ userInfo, onClose }: props) => {
    const history = useHistory()
    const userContext = useUserContext()
    const orgCtx = useOrganizationContext()
    const [showErrorReg, setShowErrorReg] = useState<LoginError>({ show: false, message: '' })
    const [termsAndConditionsAccepted, setTermsAndConditionsAccepted] = useState<boolean>(false)
    const [genderOptions, setGenderOptions] = useState<GenderOptionType[]>([])
    const [userRegFields, setUserRegFields] = useState<CreateOrgRelation>({
        id: userInfo.user.id,
        firstName: { required: true, value: userInfo.user.firstName || '' },
        lastName: { required: true, value: userInfo.user.lastName || '' },
        email: { required: true, value: userInfo.user.email || '' },
    })
    const [userLogin, setUserLogin] = useState<UserLogin>({orgId: userInfo.orgId, usrId: userInfo.usrId, user: userInfo.user})
    const [redirectOrg, setRedirectOrg] = useState<any>({
        orgId: userInfo.orgId,
        route: `/organization/${userInfo.orgId}`
    })
    const { getTranslation } = useCustomTranslation(userInfo.orgId)

    const createStringField = (isReguired: boolean, key: string): RegistrationFieldType => {
    return { required: isReguired, value: userLogin.user[key] || ''}
    }

    const createCountryField = (isReguired: boolean): RegistrationCountryFieldType => {
    return { required: isReguired, value: userLogin.user.country || '' }
    }

    const createDateField = (isReguired: boolean): RegistrationDateFieldType => {
    return { required: isReguired, value: userLogin.user.dateOfBirth || '', stringValue: '' }
    }

    useEffect(() => {
     let copy = userRegFields
     if (orgCtx && orgCtx.organization) {
        for (const [key, value] of Object.entries(orgCtx.organization.registrationFields)) {
            switch (key) {
                case 'place_of_birth':
                copy['placeOfBirth'] = createStringField(value, "placeOfBirth")
                break
                case 'street_address':
                copy['streetAddress'] = createStringField(value, "streetAddress")
                break
                case 'alias':
                copy['alias'] = createStringField(value, "alias")
                break
                case 'phone':
                copy['phone'] = createStringField(value, "phone")
                break
                case 'bio':
                copy['bio'] = createStringField(value, "bio")
                break
                case 'postalcode':
                copy['postalcode'] = createStringField(value, "postalcode")
                break
                case 'occupation':
                copy['occupation'] = createStringField(value, "occupation")
                break
                case 'gender':
                let fieldObject: RegistrationFieldType = createStringField(value, "gender")
                copy[key] = fieldObject
                break
                case 'country':
                let countryObject: RegistrationCountryFieldType = createCountryField(value)
                copy[key] = countryObject
                break

                case 'date_of_birth':
                let dateObject: RegistrationDateFieldType = createDateField(value)
                copy['dateOfBirth'] = dateObject
                break
            }
        }
        console.log(copy)
        setUserRegFields(copy)

        console.log(userContext?.loggedInUser, userLogin.user, userRegFields)
    }

    const getGenderTranslation = (key: string) => {
      switch (key) {
        case 'Female':
          return getTranslation('REGISTRATION.GENDER_FEMALE')
        case 'Male':
          return getTranslation('REGISTRATION.GENDER_MALE')
        default:
          return getTranslation('REGISTRATION.GENDER_OTHER')
      }
    }

    const genderList = [
        { value: "FEMALE", label: getGenderTranslation('Female') },
        { value: "MALE", label: getGenderTranslation('Male') },
        { value: "OTHER", label: getGenderTranslation('Other') }
      ]
      setGenderOptions(genderList)

    }, [])
    

    const _hanldeKeyDown = (e: any) => {
        if (e.key === 'Enter') {
        e.preventDefault()
        }
    }

    const onInputChange = (key: keyof CreateOrgRelation, value: string) => {
        if (showErrorReg.show) {
            setShowErrorReg({ show: false, message: '' })
        }
        console.log(key, value, userRegFields)
        let updatedValue: any
        switch (key) {
        case 'dateOfBirth':
            updatedValue = userRegFields[key]
            updatedValue.value = new Date(value)
            updatedValue.stringValue = value
            break
        default:
            updatedValue = userRegFields[key]
            updatedValue.value = value
        }
        let prevForm = userRegFields || {}
        setUserRegFields({ ...prevForm, [key]: updatedValue })
    }

    const validateForm = () => {
        if (!userRegFields) return false
        let isValid = true
        for (const value of Object.values(userRegFields)) {
            let val = typeof value === 'object' && value !== null && 'value' in value ? value.value : value
            let req = typeof value === 'object' && value !== null && 'required' in value ? value.required : value
            if (req) {
                if (typeof val === "string") {
                let valueCopy = val
                valueCopy = valueCopy.trim();
                isValid = isValid && valueCopy !== ''
                } else {
                isValid = isValid && val !== null
                }

            }
        }
        console.log(isValid, userRegFields)
        return isValid
    }


    const handleLogInNewUserSubmit = async () => {
        if (!validateForm() || !userRegFields) {
            setShowErrorReg({ show: true, message: getTranslation('REGISTRATION.MISSING_FILEDS_ERROR') })
            return
        }

        if (!termsAndConditionsAccepted) {
            setShowErrorReg({show: true, message: "You haven't accepted the terms and conditions"})
            return;
        }

        // ADD ALL FILLED IN FIELDS TO USER OBJECT
        for(const [key, field] of Object.entries(userRegFields)) {
            if (key === 'id') {
                continue
            }

            let val = typeof field === 'object' && field !== null && 'value' in field ? field.value : field

            // Special handling for country field

            if (key === 'country') {
                if ((field as RegistrationCountryFieldType).value) {
                    userLogin.user[key] = (field as RegistrationCountryFieldType).value?.value
                } else {
                    userLogin.user[key] = ''
                }
                continue
            }

            userLogin.user[key] = val
        }
        

        const respCreate = await Api.createUserOrgRelation(userLogin)

        if (!respCreate) {return;}

        ApplicationStorage.setToken(respCreate['token'])
        userContext?.setUser({ ...respCreate.user.user, roles: respCreate.user.userRoles }, respCreate.user.isPlatformAdmin)
        const resp = await Api.updateUser(userLogin.user)
        console.log(resp)
        if (!resp) {return}
        
        history.push(redirectOrg.route)
    }
    console.log(userRegFields, )
    return (
        <div className="login-container-overlay">
            <div className="login-container-popup">
                <h1 style={{color: "#000000"}}>{getTranslation('REGISTRATION.TITLE')}</h1>

                {(userRegFields?.firstName?.required && !userLogin.user.firstName )&& <Text title={`${getTranslation('REGISTRATION.FIRST_NAME')}${userRegFields.firstName.required ? '*' : ''}`} name="firstName" placeholder="First name.." onUpdate={onInputChange} handleKeyDown={_hanldeKeyDown} value={userRegFields.firstName.value} />}
                {(userRegFields?.lastName?.required && !userLogin.user.lastName) && 
                    <Text
                    title={`${getTranslation('REGISTRATION.LAST_NAME')}${userRegFields.lastName.required ? '*' : ''}`}
                    name="lastName"
                    placeholder="Last name..."
                    onUpdate={onInputChange}
                    handleKeyDown={_hanldeKeyDown}
                    value={userRegFields.lastName.value} />}
                {(userRegFields?.email?.required && !userLogin.user.email) && <Text title={`${getTranslation('REGISTRATION.EMAIL')}${userRegFields.email.required ? '*' : ''}`} name="email" placeholder="" onUpdate={onInputChange} handleKeyDown={_hanldeKeyDown} value={userRegFields.email.value} />}
                {(userRegFields?.alias?.required && !userLogin.user.alias) &&
                (<Text
                    title={`${getTranslation('REGISTRATION.ALIAS')}${userRegFields.alias.required ? '*' : ''}`}
                    name="alias"
                    placeholder=""
                    onUpdate={onInputChange}
                    handleKeyDown={_hanldeKeyDown}
                    value={userRegFields.alias.value}
                    toolTip={getTranslation('REGISTRATION.ALIAS_TOOLTIP_TEXT')} />)}
                {(userRegFields?.phone?.required && !userLogin.user.phone) &&
                (<NumberField title={`${getTranslation('REGISTRATION.PHONE')}${userRegFields.phone.required ? '*' : ''}`} name="phone" placeholder="" onUpdate={onInputChange} handleKeyDown={_hanldeKeyDown} value={userRegFields.phone.value} />)}
                {(userRegFields?.dateOfBirth?.required && ((userLogin.user.dateOfBirth === "0001-01-01T00:00:00Z") || !userLogin.user.dateOfBirth)) && //Default date is "0001-01-01T00:00:00Z", so check for that val
                (<DatePicker
                    title={`${getTranslation('REGISTRATION.DATEOFBIRTH')}${userRegFields.dateOfBirth.required ? '*' : ''}`}
                    name="dateOfBirth"
                    placeholder="yyyy-mm-dd"
                    onUpdate={(key: keyof CreateOrgRelation, value: string) => onInputChange(key, value)}
                    value={userRegFields.dateOfBirth.stringValue}
                    handleKeyDown={_hanldeKeyDown} />)}
                {(userRegFields?.placeOfBirth?.required && !userLogin.user.placeOfBirth) &&
                (<Text title={`${getTranslation('REGISTRATION.PLACEOFBIRTH')}${userRegFields.placeOfBirth.required ? '*' : ''}`} name="placeOfBirth" placeholder="" onUpdate={onInputChange} handleKeyDown={_hanldeKeyDown} value={userRegFields.placeOfBirth.value} />)
                }
                {(userRegFields?.bio?.required && !userLogin.user.bio) &&
                (<TextArea
                    title={`${getTranslation('REGISTRATION.BIO')}${userRegFields.bio.required ? '*' : ''}`}
                    name="bio" placeholder="" onUpdate={onInputChange}
                    handleKeyDown={_hanldeKeyDown}
                    value={userRegFields.bio.value} />)}
                {(userRegFields?.gender?.required && !userLogin.user.gender) &&
                (<DropDownSelect title={`${getTranslation('REGISTRATION.GENDER')}${userRegFields.gender.required ? '*' : ''}`} options={genderOptions} onUpdate={(opt: GenderOptionType) => onInputChange('gender', opt.label)} selectedValue={userRegFields.gender.value} closeOnSelect={true} />)}
                {(userRegFields?.country?.required && !userLogin.user.country) &&
                (<CountriesDropDown
                    title={`${getTranslation('REGISTRATION.COUNTRY')}${userRegFields.country.required ? '*' : ''}`}
                    onUpdate={(country: any) => {
                    onInputChange('country', country)
                    }}
                    selectedCountry={userRegFields.country.value ? userRegFields.country.value.label : null} />)}

                {(userRegFields?.streetAddress?.required && !userLogin.user.streetAddress) &&
                (<Text title={`${getTranslation('REGISTRATION.STREET_ADDRESS')}${userRegFields.streetAddress.required ? '*' : ''}`} name="streetAddress" placeholder="" onUpdate={onInputChange} handleKeyDown={_hanldeKeyDown} value={userRegFields.streetAddress.value} />)}
                {(userRegFields?.postalcode?.required && !userLogin.user.postalcode) && (<Text title={`${getTranslation('REGISTRATION.POSTAL_CODE')}${userRegFields.postalcode.required ? '*' : ''}`} name="postalcode" placeholder="" onUpdate={onInputChange} handleKeyDown={_hanldeKeyDown} value={userRegFields.postalcode.value} />)}
                {(userRegFields?.occupation?.required &&  !userLogin.user.occupation) && (<Text title={`${getTranslation('REGISTRATION.OCCUPATION')}${userRegFields.occupation.required ? '*' : ''}`} name="occupation" placeholder="" onUpdate={onInputChange} handleKeyDown={_hanldeKeyDown} value={userRegFields.occupation.value} />)}

                <CustomCheckbox
                    text={<a id="register-terms-conditions" href={`${redirectOrg.route}/terms-and-conditions`} target="_blank" rel="noreferrer">{getTranslation('REGISTRATION.ACCEPT_TERMS_CONDITIONS')}</a>}
                    value={termsAndConditionsAccepted}
                    onUpdate={() => {
                    setTermsAndConditionsAccepted(!termsAndConditionsAccepted)
                    }}
                />

                <div className="login-error-div">
                    {showErrorReg.show && (
                    <p className="login-error">* {showErrorReg.message}</p>
                    )}
                </div>
                <div className="login-register-btns-container">
                    <button className="btn btn-default btn-stnd-al" onClick={handleLogInNewUserSubmit}>{getTranslation('LOGIN.REGISTER')}</button>
                    <button className="btn btn-default btn-stnd-al" onClick={() => onClose()}>{'Cancel'}</button>
                </div>
            </div>
        </div>
    );
}